// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/about.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/m2r2-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-body-bg {
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.main-container{
    margin: auto;
    width: 70%;
  }

  .header{
    height: 110px;
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    background-color: inherit;
    transition: background-color 0.8s ease;
	  position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99
  }

  .header.visible {
    background: linear-gradient(to bottom, rgba(11, 151, 220, 1), rgba(0, 0, 0, 0.8));
    color:white; /* Background color when header is visible */
  }

  .header-blocks{
    display:flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
  }

  .header-block-1{
    width: 130px;
    height: 105px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size:contain;
    background-position: center;
    cursor: pointer;
  }
  .header-block-2{
    width: 50%;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;

  }
  .header-block-4{
    position: fixed; /* Fixed position for mobile menu */
    top: 75px;
    right: 0;
    background-color: #282828;
    height: 100vh; /* Full viewport height for mobile menu */
    z-index: 99; /* Ensure mobile menu is above other content */
    display: none; /* Initially hide the mobile menu */
    transition: opacity 0.3s ease; /* Add transition animation for opacity */
    align-items: center;
    justify-content: center;
    text-align: center;

  }

  .header-action-button{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: white;
    cursor: pointer;
  }

  .header-action-button:hover{
    color: black;
  }

  .book-demo-action-button{
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0094DC;
    padding: 8px 20px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 20px;
  }

  .book-demo-action-button:hover{
    background-color: black;
    color: white;
  }
  
  .dropdown {
    position: relative;
    display: inline-block;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
  }
  
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #282828;
    
    min-width: 180px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
  }
  
  .dropdown-content-text {
    color: white;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    border-bottom: 1px solid black;
  }
  
  .dropdown-content-text:hover {background-color: black;
    color: white;
    font-weight: bold;
  }
  
  .dropdown:hover .dropdown-content {display: block;}



  .header-block-3{
    width: 40px;
    height: 30px;
    display: none;
  }              
  .handburgericon{
    width: 80%;
    margin: auto;
    background-color: white;
    height: 5px;
    margin-bottom: 5px;
    border-radius: 1px;
  }


  .header-block-4.show-mobile-menu {
    display: block;
    width: 60%;
    opacity: 1;
  }


  @keyframes slideInFromRight {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0);
    }
  }
  
  /* Add animation for sliding out to right */
  @keyframes slideOutToRight {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(100%);
    }
  }

/* Media query for smaller screen sizes */
@media screen and (max-width: 700px) {
  .main-container {
    width: 90%;
    height: max-content;
    overflow-x: hidden; /* Disable horizontal scrolling on phone screens */
  }
  .header{
    height: 60px;
  }
  .header-blocks{
    height: 50px;
  }
  .header-block-1{
    width: 90px;
    height: 80px;
  }
  .header-block-3{
    display: inline-block;
  }
  .header-block-2{
    display: none;
  }
  .header-block-4 {
    width: 80%;
    animation: slideInFromRight 0.3s ease; /* Apply slide in animation */
  }

  /* Apply slide out animation when hiding */
  .header-block-4:not(.show-mobile-menu) {
    animation: slideOutToRight 0.3s ease;
    display: none;
  }
}
  
`, "",{"version":3,"sources":["webpack://./src/components/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,yDAA8C;EAC9C,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;IACI,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,sCAAsC;GACvC,eAAe;IACd,MAAM;IACN,OAAO;IACP,WAAW;IACX;EAEF;;EAEA;IACE,iFAAiF;IACjF,WAAW,EAAE,4CAA4C;EAC3D;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,yDAAkD;IAClD,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;;EAEpB;EACA;IACE,eAAe,EAAE,mCAAmC;IACpD,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,aAAa,EAAE,yCAAyC;IACxD,WAAW,EAAE,8CAA8C;IAC3D,aAAa,EAAE,mCAAmC;IAClD,6BAA6B,EAAE,yCAAyC;IACxE,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;;EAEpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,yBAAyB;;IAEzB,gBAAgB;IAChB,4CAA4C;IAC5C,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,8BAA8B;EAChC;;EAEA,8BAA8B,uBAAuB;IACnD,YAAY;IACZ,iBAAiB;EACnB;;EAEA,mCAAmC,cAAc,CAAC;;;;EAIlD;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;IACE,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;;;EAGA;IACE,cAAc;IACd,UAAU;IACV,UAAU;EACZ;;;EAGA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,wBAAwB;IAC1B;EACF;;EAEA,2CAA2C;EAC3C;IACE;MACE,wBAAwB;IAC1B;IACA;MACE,2BAA2B;IAC7B;EACF;;AAEF,yCAAyC;AACzC;EACE;IACE,UAAU;IACV,mBAAmB;IACnB,kBAAkB,EAAE,kDAAkD;EACxE;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,qCAAqC,EAAE,6BAA6B;EACtE;;EAEA,0CAA0C;EAC1C;IACE,oCAAoC;IACpC,aAAa;EACf;AACF","sourcesContent":[".landing-body-bg {\n  width: 100%;\n  height: 100%;\n  background-image: url(\"/src/assets/about.jpg\");\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.main-container{\n    margin: auto;\n    width: 70%;\n  }\n\n  .header{\n    height: 110px;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    background-color: inherit;\n    transition: background-color 0.8s ease;\n\t  position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 99;\n    transition: 'top 0.9s',\n  }\n\n  .header.visible {\n    background: linear-gradient(to bottom, rgba(11, 151, 220, 1), rgba(0, 0, 0, 0.8));\n    color:white; /* Background color when header is visible */\n  }\n\n  .header-blocks{\n    display:flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    height: 100%;\n  }\n\n  .header-block-1{\n    width: 130px;\n    height: 105px;\n    background-image: url(\"/src/assets/m2r2-logo.png\");\n    background-repeat: no-repeat;\n    background-size:contain;\n    background-position: center;\n    cursor: pointer;\n  }\n  .header-block-2{\n    width: 50%;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 20px;\n\n  }\n  .header-block-4{\n    position: fixed; /* Fixed position for mobile menu */\n    top: 75px;\n    right: 0;\n    background-color: #282828;\n    height: 100vh; /* Full viewport height for mobile menu */\n    z-index: 99; /* Ensure mobile menu is above other content */\n    display: none; /* Initially hide the mobile menu */\n    transition: opacity 0.3s ease; /* Add transition animation for opacity */\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n\n  }\n\n  .header-action-button{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    color: white;\n    cursor: pointer;\n  }\n\n  .header-action-button:hover{\n    color: black;\n  }\n\n  .book-demo-action-button{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #0094DC;\n    padding: 8px 20px;\n    border-radius: 10px;\n    cursor: pointer;\n    font-size: 20px;\n  }\n\n  .book-demo-action-button:hover{\n    background-color: black;\n    color: white;\n  }\n  \n  .dropdown {\n    position: relative;\n    display: inline-block;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;\n  }\n  \n  .dropdown-content {\n    display: none;\n    position: absolute;\n    background-color: #282828;\n    \n    min-width: 180px;\n    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n    z-index: 1;\n  }\n  \n  .dropdown-content-text {\n    color: white;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n    border-bottom: 1px solid black;\n  }\n  \n  .dropdown-content-text:hover {background-color: black;\n    color: white;\n    font-weight: bold;\n  }\n  \n  .dropdown:hover .dropdown-content {display: block;}\n\n\n\n  .header-block-3{\n    width: 40px;\n    height: 30px;\n    display: none;\n  }              \n  .handburgericon{\n    width: 80%;\n    margin: auto;\n    background-color: white;\n    height: 5px;\n    margin-bottom: 5px;\n    border-radius: 1px;\n  }\n\n\n  .header-block-4.show-mobile-menu {\n    display: block;\n    width: 60%;\n    opacity: 1;\n  }\n\n\n  @keyframes slideInFromRight {\n    0% {\n      transform: translateX(100%);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n  \n  /* Add animation for sliding out to right */\n  @keyframes slideOutToRight {\n    0% {\n      transform: translateX(0);\n    }\n    100% {\n      transform: translateX(100%);\n    }\n  }\n\n/* Media query for smaller screen sizes */\n@media screen and (max-width: 700px) {\n  .main-container {\n    width: 90%;\n    height: max-content;\n    overflow-x: hidden; /* Disable horizontal scrolling on phone screens */\n  }\n  .header{\n    height: 60px;\n  }\n  .header-blocks{\n    height: 50px;\n  }\n  .header-block-1{\n    width: 90px;\n    height: 80px;\n  }\n  .header-block-3{\n    display: inline-block;\n  }\n  .header-block-2{\n    display: none;\n  }\n  .header-block-4 {\n    width: 80%;\n    animation: slideInFromRight 0.3s ease; /* Apply slide in animation */\n  }\n\n  /* Apply slide out animation when hiding */\n  .header-block-4:not(.show-mobile-menu) {\n    animation: slideOutToRight 0.3s ease;\n    display: none;\n  }\n}\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
